module.exports = __webpack_public_path__ + "img/antes_despues_309.e9fadae1.png";